export default [
  {
    name: 'api-bridge-webfleet-create',
    path: '/api-bridges/webfleet/create',
    component: () => import('@/views/api-bridges/webfleet/ApiBridgeWebfleetManage.vue')
  },
  {
    name: 'api-bridge-webfleet-edit',
    path: '/api-bridges/webfleet/:id/edit',
    component: () => import('@/views/api-bridges/webfleet/ApiBridgeWebfleetManage.vue')
  },
  {
    name: 'api-bridge-webfleet-view',
    path: '/api-bridges/webfleet/:id/view',
    component: () => import('@/views/api-bridges/webfleet/ApiBridgeWebfleetManage.vue')
  },
  {
    name: 'api-bridge-webfleet-find',
    path: '/api-bridges/webfleet/find',
    component: () => import('@/views/api-bridges/webfleet/ApiBridgeWebfleetFind.vue')
  },
  {
    name: 'api-bridge-rabbitmq-create',
    path: '/api-bridges/rabbitmq/create',
    component: () => import('@/views/api-bridges/rabbitmq/ApiBridgeRabbitMqManage.vue')
  },
  {
    name: 'api-bridge-rabbitmq-edit',
    path: '/api-bridges/rabbitmq/:id/edit',
    component: () => import('@/views/api-bridges/rabbitmq/ApiBridgeRabbitMqManage.vue')
  },
  {
    name: 'api-bridge-rabbitmq-view',
    path: '/api-bridges/rabbitmq/:id/view',
    component: () => import('@/views/api-bridges/rabbitmq/ApiBridgeRabbitMqManage.vue')
  },
  {
    name: 'api-bridge-rabbitmq-find',
    path: '/api-bridges/rabbitmq/find',
    component: () => import('@/views/api-bridges/rabbitmq/ApiBridgeRabbitMqFind.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeApiBridges.js